import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center mb-4">
              <img src="https://sharpautorepair.com/sharp_auto_repair_logo.svg" alt="Sharp Deal Auto Repair Logo" className="w-64 h-12" />
            </div>
            <p className="text-gray-400 text-sm">
              Professional automotive repair services you can trust.
              Serving Hialeah for over 25 years.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="#services" className="hover:text-white transition-colors">Services</a></li>
              <li><a href="#reviews" className="hover:text-white transition-colors">Customer Reviews</a></li>
              <li><a href="#contact" className="hover:text-white transition-colors">Contact Us</a></li>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <li><a href="#" className="hover:text-white transition-colors">About Us</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Services</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <li><a href="#" className="hover:text-white transition-colors">Brake Repair</a></li>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <li><a href="#" className="hover:text-white transition-colors">Engine Diagnostics</a></li>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <li><a href="#" className="hover:text-white transition-colors">Transmission</a></li>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <li><a href="#" className="hover:text-white transition-colors">AC Service</a></li>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <li><a href="#" className="hover:text-white transition-colors">Oil Changes</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">Contact Info</h4>
            <div className="space-y-2 text-sm text-gray-400">
              <div className="flex items-center">
                <FontAwesomeIcon icon={faPhone} className="w-5 mr-2" />
                <a href="tel:3058210101" className="hover:text-white">(305) 821-0101</a>
              </div>
              <div className="flex items-center">
                <FontAwesomeIcon icon={faEnvelope} className="w-5 mr-2" />
                <a href="mailto:info@sharpdealauto.com" className="hover:text-white">info@sharpdealauto.com</a>
              </div>
              <div className="flex items-center">
                <FontAwesomeIcon icon={faMapMarkerAlt} className="w-5 mr-2" />
                <span>Hialeah, FL</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400 text-sm">
          <p>&copy; {new Date().getFullYear()} Sharp Deal Auto Repair Inc. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;